import React from 'react';
import SEO from '../components/SEO';

const ESProjektai = () => {
  return (
    <div>
      <SEO 
        title="ES Projektai"
        description="UAB Sporto krantas ES finansuojami projektai - saulės elektrinės įrengimas pagal Naujos kartos Lietuva planą."
        keywords="ES projektai, saulės elektrinė, NextGenerationEU, Naujos kartos Lietuva, sporto krantas"
        canonicalUrl="https://sportokrantas.lt/es-projektai"
      />
      <section className="py-12 border-b-[3px] border-black bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-black mb-8 tracking-wide leading-tight text-center" style={{ fontSize: '29.5px', fontWeight: 700, WebkitTextStroke: '0.5px' }}>
            ES PROJEKTAI
          </h1>
          
          <div className="prose prose-lg max-w-none text-black">
            <div className="mb-8">
              <img 
                src="/img/3D5C0700-B160-4541-B7A5-386B5CBF9881.jpeg" 
                alt="ES Projektas - Saulės elektrinė" 
                className="w-full max-w-2xl mx-auto rounded-lg shadow-lg"
              />
            </div>

            <h2 className="text-xl font-bold mt-8 mb-4">Investicinė parama saulės elektrinėms</h2>
            
            <p className="mb-6">
              UAB „Sporto krantas" pasinaudojo VŠĮ „Lietuvos energetikos agentūra" kvietimu Nr. 03-005-J-0001-J06 „Investicinė parama saulės elektrinėms sausumoje" ir įgyvendino projektą įsirengdamas 28,95 kW galios saulės modulių elektrinę adresu Liepų g. 63, Daukšiai, Sužionių sen., Vilniaus rajone.
            </p>

            <p className="mb-6">
              <strong>Projekto vykdymo laikotarpis:</strong> 2025-02-11 – 2025-03-31
            </p>

            <div className="bg-gray-50 border-l-4 border-[#D0AB64] p-6 my-8">
              <p className="text-gray-700">
                Jungtinis projektas įgyvendinamas pagal ekonomikos gaivinimo ir atsparumo didinimo planą „Naujos kartos Lietuva", finansuojamą Europos Sąjungos ekonomikos gaivinimo ir atsparumo didinimo priemonės „NextGenerationEU" lėšomis.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ESProjektai;
